import { useEffect } from "react";
import Navigation from "../components/navigation";
import VisionMovies from "../components/visionmoviesScreen/index";
import { useTheme } from "@mui/material/styles";

export default function VisionMoviesRoute({ proAccount }) {
  const theme = useTheme();

  return (
    <div
      style={{
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        marginBottom: theme.spacing(8),
      }}
    >
      <Navigation proAccount={proAccount} />
      <div style={{ paddingTop: 60, overflow: "hidden" }}>
        <VisionMovies />
      </div>
    </div>
  );
}
